import { ActionContext } from "vuex";
import { PaginatedReleaseNotes, ReleaseNote } from "@tt-app/types/releaseNotes/api";
import { RootState } from "@tt-app/store/root/types";

export interface ReleaseNotesState {
  paginatedReleaseNotes?: PaginatedReleaseNotes;
  loading: boolean;
}

export const ReleaseNotesNamespace = "releaseNotes";
export type S = ReleaseNotesState;
export type R = RootState;

export enum ReleaseNotesMutationNames {
  RELEASE_NOTES = "RELEASE_NOTES",
  SET_LOADING = "SET_LOADING"
}
export interface ReleaseNotesMutations {
  [ReleaseNotesMutationNames.RELEASE_NOTES](state: S, payload: PaginatedReleaseNotes): void;
  [ReleaseNotesMutationNames.SET_LOADING](state: S, payload: boolean): void;
}

export enum ReleaseNotesGetterNames {
  RELEASE_NOTES = "RELEASE_NOTES",
  IS_LOADING = "IS_LOADING"
}
export interface ReleaseNotesGetters {
  [ReleaseNotesGetterNames.RELEASE_NOTES](state: S, getters: any): undefined | ReleaseNote[];
  [ReleaseNotesGetterNames.IS_LOADING](state: S, getters: any): boolean;
}

interface AugmentedActionContext extends Omit<ActionContext<S, R>, "commit"> {
  commit<K extends keyof ReleaseNotesMutations>(
    key: K,
    payload?: Parameters<ReleaseNotesMutations[K]>[1]
  ): ReturnType<ReleaseNotesMutations[K]>;
}

export enum ReleaseNotesActionNames {
  REQUEST_RELEASE_NOTES = "REQUEST_RELEASE_NOTES"
}
export interface ReleaseNotesActions {
  [ReleaseNotesActionNames.REQUEST_RELEASE_NOTES](context: AugmentedActionContext): Promise<void>;
}
